import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["id", "startIcon", "endIcon", "className", "size", "children", "closable", "shape", "color", "bordered", "dark", "onClose", "title"];

/* eslint-disable react/destructuring-assignment */
import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import Label from '../Label';
import Icon from '../Icon';
import { isEmpty } from '../tools/util';
import ConfigConsumerProvider from '../ConfigConsumerProvider';

function Tag(_ref) {
  var id = _ref.id,
      startIcon = _ref.startIcon,
      endIcon = _ref.endIcon,
      className = _ref.className,
      size = _ref.size,
      children = _ref.children,
      closable = _ref.closable,
      shape = _ref.shape,
      color = _ref.color,
      bordered = _ref.bordered,
      dark = _ref.dark,
      onClose = _ref.onClose,
      title = _ref.title,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var tooltipConfig = {
    theme: 'light',
    placement: 'bottom'
  };
  return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
    size: size
  }, function (_ref2) {
    var _classNames;

    var configSize = _ref2.size;
    return /*#__PURE__*/React.createElement("div", _extends({
      id: id,
      className: classNames('jmtd-tag', className, (_classNames = {}, _defineProperty(_classNames, "jmtd-tag-".concat(shape), !!shape), _defineProperty(_classNames, "jmtd-tag-".concat(color), !!color), _defineProperty(_classNames, 'jmtd-tag-mini', configSize === 'mini'), _defineProperty(_classNames, 'jmtd-tag-small', configSize === 'small'), _defineProperty(_classNames, 'jmtd-tag-large', configSize === 'large'), _defineProperty(_classNames, 'jmtd-tag-bordered', bordered), _defineProperty(_classNames, 'jmtd-tag-dark', dark), _defineProperty(_classNames, 'jmtd-tag-empty', isEmpty(children)), _classNames))
    }, otherProps), startIcon && /*#__PURE__*/cloneElement(startIcon, {
      className: classNames(startIcon.props.className, 'jmtd-tag-start-icon')
    }), /*#__PURE__*/React.createElement(Label, _extends({
      title: title
    }, tooltipConfig), children), closable && /*#__PURE__*/React.createElement(Icon, {
      className: "jmti-close jmtd-tag-close-icon",
      onClick: onClose
    }), endIcon && /*#__PURE__*/cloneElement(endIcon, {
      className: classNames(endIcon.props.className, 'jmtd-tag-end-icon')
    }));
  });
}

Tag.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  closable: PropTypes.bool,
  bordered: PropTypes.bool,
  dark: PropTypes.bool,
  color: PropTypes.string,
  // primary、info、success、help、warning、danger
  size: PropTypes.oneOf(['mini', 'middle', 'small', 'large']),
  shape: PropTypes.oneOf(['normal', 'capsule']),
  onClose: PropTypes.func,
  style: PropTypes.any,
  title: PropTypes.node,
  onClick: PropTypes.func
};
Tag.defaultProps = {
  id: null,
  children: null,
  className: '',
  startIcon: null,
  endIcon: null,
  closable: false,
  bordered: false,
  dark: false,
  color: '',
  size: null,
  shape: null,
  onClose: function onClose() {},
  style: {},
  title: null,
  onClick: function onClick() {}
};
export default Tag;